// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__zTU27","rotate":"styles_rotate__hPPzs","rotate-reverse":"styles_rotate-reverse__8YQL4"};